<template>
  <v-row class="mx-auto">
    <v-col cols="12">
      <base-material-card
        color="primary"
        icon="mdi-barcode-scan"
        inline
        class="px-5 py-4"
      >
        <template v-slot:after-heading>
          <div class="display-2-custom font-weight-light title-page-bp">
            {{title}}
          </div>
        </template>
        <v-form class="pt-5">
          <v-row class="mx-auto">
            <v-col cols=12 class="title-bp">
              <validation-provider v-slot="{ errors }" rules="required">
                <v-text-field
                  id="titulo-calculo-bp"
                  label="Título"
                  outlined
                  :error-messages="errors"
                  v-model="campos.titulo"
                />
              </validation-provider>
            </v-col>
          </v-row>
          <v-row class="mx-auto">
            <v-col cols="3" class="col-date-bp">
              <v-menu
                v-model="menuDataCompra"
                :close-on-content-click="false"
                :nudge-right="100"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <validation-provider v-slot="{ errors }" rules="required|min:10">
                    <v-text-field
                      id="date-picker-data-inicial-calculo-bp"
                      :error-messages="errors"
                      type="tel" v-mask="'##/##/####'"
                      v-model="campos.dataCompraFormatted"
                      label="Data Compra"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      @blur="campos.dataCompra = parseDate(campos.dataCompraFormatted)"
                    />
                  </validation-provider>
                </template>
                <v-date-picker 
                  v-model="campos.dataCompra"
                  @input="menuDataCompra = false; campos.dataCompraFormatted = formatDate(campos.dataCompra)"
                  locale="pt-br"
                />
              </v-menu>
            </v-col>
            <v-col class="text-center px-0 col-divisor-date-bp" style="min-width:60px !important;" cols="1">
              <span style="color: rgba(0, 0, 0, 0.54); font-size:15px">até</span> 
            </v-col>
            <v-col cols="3" class="col-date-bp">
              <v-menu
                v-model="menuDataCompraAte"
                :close-on-content-click="false"
                :nudge-right="100"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <validation-provider v-slot="{ errors }" rules="required|min:10">
                    <v-text-field
                      id="date-picker-data-final-calculo-bp"
                      :error-messages="errors"
                      type="tel" v-mask="'##/##/####'"
                      v-model="campos.dataCompraFormattedAte"
                      label="Data Compra"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      @blur="campos.dataCompraAte = parseDate(campos.dataCompraFormattedAte)"
                    />
                  </validation-provider>
                </template>
                <v-date-picker 
                  v-model="campos.dataCompraAte"
                  @input="menuDataCompraAte = false; campos.dataCompraFormattedAte = formatDate(campos.dataCompraAte)"
                  locale="pt-br"
                />
              </v-menu>
            </v-col>
          </v-row>
          <v-row class="mx-auto">
            <v-col cols="3" class="col-date-bp last-date-page-bp">
              <v-menu
                v-model="menuDataBase"
                :close-on-content-click="false"
                :nudge-right="100"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <validation-provider v-slot="{ errors }" rules="required|min:7">
                    <v-text-field
                      id="date-picker-database-calculo-bp"
                      :error-messages="errors"
                      type="tel" v-mask="'##/####'"
                      v-model="campos.monthDataBaseFormatted"
                      label="Data Base"
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      @blur="campos.monthDataBase = parseMonth(campos.monthDataBaseFormatted)"
                    />
                  </validation-provider>
                </template>
                <v-date-picker 
                  v-model="campos.monthDataBase"
                  @input="menuDataBase = false; campos.monthDataBaseFormatted = formatMonth(campos.monthDataBase)"
                  type="month" 
                  :landscape="false"
                  locale="pt-br"
                />
              </v-menu>
            </v-col>
          </v-row>
        </v-form>
      </base-material-card>
    </v-col>
  </v-row>
</template>

<script>
import dateFormatterMixins from "@/mixins/dateFormatterMixins";

export default {
  mixins: [dateFormatterMixins],

  props: {
    title: {
      type: String,
      required:true
    },
    items: {
      type: Object,
      default: ()=> {}
    }
  },

  mounted() {
    if (this.$route.params.id) {
      this.fillFields();
    }
  },

  data() {
    return {
      menuDataCompra: false,
      menuDataCompraAte: false,
      menuDataBase: false,
      campos: {
        titulo: '',
        dataCompra: '',
        dataCompraAte: '',
        monthDataBase: '',
        dataCompraFormatted: '',
        dataCompraFormattedAte: '',
        monthDataBaseFormatted: ''
      }
    }
  },

  methods: {
    fillFields() {
      let bancoPrecosCalculos = this.items;

      this.campos = {
        titulo: bancoPrecosCalculos.titulo,
        dataCompraFormatted: bancoPrecosCalculos.data_inicial ? this.formatDate(bancoPrecosCalculos.data_inicial) : '',
        dataCompra: bancoPrecosCalculos.data_inicial ? this.formatDateToPicker(bancoPrecosCalculos.data_inicial) : '',
        dataCompraFormattedAte: bancoPrecosCalculos.data_final ? this.formatDate(bancoPrecosCalculos.data_final) : '',
        dataCompraAte: bancoPrecosCalculos.data_final ? this.formatDateToPicker(bancoPrecosCalculos.data_final) : '',
        monthDataBaseFormatted: bancoPrecosCalculos.data_base ? this.formatMonth(bancoPrecosCalculos.data_base) : '',
        monthDataBase: bancoPrecosCalculos.data_base ? this.formatMonthToPicker(bancoPrecosCalculos.data_base) : '',
      };
    },

    exportData() {
      return {
        titulo: this.campos.titulo,
        data_inicial: this.campos.dataCompra,
        data_final: this.campos.dataCompraAte,
        data_base: this.campos.monthDataBase+'-01',
      };
    },
  },

  watch: {
    items() {
      this.fillFields();
    }
  }
}
</script>

<style>
.col-date-bp {
  min-width: 160px !important;
}
.col-divisor-date-bp {
  padding-top: 36px;
}

.display-2-custom {
  font-size: 1.5625rem;
  font-weight: 400;
  line-height: 1.4em;
  letter-spacing: normal !important;
  font-family: "Gotham Rounded" !important;
}

@media screen and (max-width: 492px) {
  .col-date-bp {
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
    min-width: 100%;
    padding-bottom: 0px;
    padding-top: 0px;
  }
  .col-divisor-date-bp {
    padding: 0 12px 0 12px !important;
    margin-top: -10px;
    margin-bottom: -10px;
    margin-left: auto;
    margin-right: auto;
    width: 6em
  }

  .title-bp {
    margin-bottom: 0px;
    padding-bottom: 0px;
  }

  .last-date-page-bp{
    margin-top:8px
  }

  .display-2-custom {
    font-size: 1.5625rem;
    font-weight: 400;
    line-height: 1.4em;
    letter-spacing: normal !important;
    font-family: "Gotham Rounded" !important;
  }

  .title-page-bp {
    font-size: 3.6vw !important;
  }
}
</style>